import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Menu, Divider } from 'antd'
import { useDispatch } from 'react-redux'
import { logout } from '../../../features/auth/apis/authSlice'
import useTranslation from '../../../hooks/useTranslation'

import navTree from '../../../config/NavTree'
import Logout from '../../svgs/sider/Logout'

export default function MenuContent({ onNavigate }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { pathname, asPath, push } = useRouter()
  const dashboardPath = asPath.split('?')[0]

  const handleNavigate = () => {
    if (typeof onNavigate === 'function') {
      onNavigate()
    }
  }

  const getDashboardMenuPath = (path) => `/dashboard/${path}`
  const isSubMenuActive = (path) => dashboardPath === getDashboardMenuPath(path)
  const isMenuActive = (menu) => {
    if (pathname.split('/')[2] === menu.path) {
      return true
    }

    return Array.isArray(menu.submenu)
      ? menu.submenu.some((subMenu) => isSubMenuActive(subMenu.path))
      : false
  }

  return (
    <>
      <Menu mode='inline'>
        {navTree.map((menu, index) => (
          <React.Fragment key={index}>
            {Array.isArray(menu.submenu) ? (
              <React.Fragment key={`submenu-${menu.key}`}>
                <Menu.SubMenu
                  key={menu.key}
                  icon={isMenuActive(menu) ? menu.iconActive : menu.icon}
                  title={t(menu.title)}
                >
                  {menu.submenu.map((subMenu) => {
                    const subMenuPath = getDashboardMenuPath(subMenu.path)

                    return (
                      <Menu.Item
                        key={subMenu.key}
                        className={`${isSubMenuActive(subMenu.path) ? 'active' : ''}`}
                      >
                        <Link
                          href={subMenuPath}
                          className='flex items-center justify-between w-full'
                          onClick={handleNavigate}
                        >
                          <span>{t(subMenu.title)}</span>
                          {subMenu.count ? (
                            <span
                              className={`inline-block w-[24px] h-[24px] text-[10px] ${
                                isSubMenuActive(subMenu.path)
                                  ? 'bg-green text-white'
                                  : 'bg-green_200'
                              } rounded-full text-center font-bold leading-[24px] mx-8`}
                            >
                              {subMenu.count}
                            </span>
                          ) : null}
                        </Link>
                      </Menu.Item>
                    )
                  })}
                </Menu.SubMenu>
              </React.Fragment>
            ) : (
              <Menu.Item
                key={menu.key}
                icon={isMenuActive(menu) ? menu.iconActive : menu.icon}
                className={`${isMenuActive(menu) ? 'active' : ''}`}
                onClick={() => {
                  handleNavigate()
                  push(`/dashboard/${menu.path}`)
                }}
              >
                {t(menu.title)}
              </Menu.Item>
            )}
          </React.Fragment>
        ))}

        <Divider className='my-0 border-[#48688B]' />

        <Menu.Item
          key='logout'
          icon={<Logout />}
          onClick={() => {
            handleNavigate()
            dispatch(logout())
            push('/')
          }}
        >
          {t('sidenav.logout')}
        </Menu.Item>
      </Menu>
    </>
  )
}
